const $ = jQuery.noConflict()
function noSundays(date) {
      return [date.getDay() != 0, ''];
}
var self = module.exports = {
  props: {
    options: {
      minDate: 0,
      maxDate: '+1M +10D',
      dateFormat: 'dd / mm / y',
      beforeShowDay: noSundays
    },
    
    icon: '[data-date-trigger]',
  },

  init: function(selector) {
    $(selector).each(function() {
      $(this).datepicker(self.props.options)
      $(this).datepicker().datepicker('setDate', 'today');
    })

    self.events.iconClick(self.props.icon)
  },

  events: {
    iconClick: function(trigger) {
      $(document).on('click', trigger, function(e) {
        var input = $(this).siblings('[data-date]')
        $(input).datepicker('show')
      })
    }
  },

  service: {

  }
}

